"use client";
import Link from "next/link";
import SVG from "react-inlinesvg";
import { usePathname } from "next/navigation";

export default function Menu({ isGreen = false }) {
  const pathname = usePathname();
  return (
    <div className={`menu-container sizeContainer${isGreen ? " green" : ""}`}>
      <div className="menu-credit pcOnly">
        
        <div className="bginc-logo en">
          <span>©BG inc.</span>
        </div>
        <Link className="logo-ngr scaleHover" href="/">
          <SVG src="/assets/img/common/ngr-logo.svg"/>
        </Link>
        
      </div>

      <div className="nav-list n1">
        <Link className={`nav-item home scaleHover opacity ${pathname=="/"?"current":""}`} href="/">
          <div className="title">
            <div className="en">Home</div>
          </div>
        </Link>
        <Link className={`nav-item scaleHover opacity ${pathname=="/vegetables/"?"current":""}`} href="/vegetables/">
          <div className="title">
            <div className="en">Vegetables</div>
            <div className="sub-title">食べる革命｜Next Green Vegetables</div>
          </div>
        </Link>
        <div className="nav-item">
          <Link className={`scaleHover opacity border ${pathname=="/method/"?"current":""}`} href="/method/">
            <div className="title">
              <div className="en">Method</div>
              <div className="sub-title">つくる革命｜Next Green Method</div>
            </div>
          </Link>
          <div className="nav-group">
            <Link className={`nav-item scaleHover opacity ${pathname=="/method/soil-solution/"?"current":""}`} href="/method/soil-solution/">
              <div className="title en">Soil Solution</div>
            </Link>
            <Link className={`nav-item scaleHover opacity ${pathname=="/method/agrilca/"?"current":""}`} href="/method/agrilca/">
              <div className="title en">Agri LCA+</div>
            </Link>
            <Link className={`nav-item scaleHover opacity ${pathname=="/method/next-green-credit/"?"current":""}`} href="/method/next-green-credit/">
              <div className="title en">Next Green Credit</div>
            </Link>
          </div>
        </div>
        <Link className={`nav-item scaleHover opacity ${pathname=="/10rules/"?"current":""}`} href="/10rules/">
          <div className="title en">
            10 Rules
            <div className="sub-title">10の合言葉</div>
          </div>
        </Link>
        <Link className={`nav-item scaleHover opacity ${pathname=="/about/"?"current":""}`} href="/about/">
          <div className="title en">
            About Us
            <div className="sub-title">わたしたちについて</div>
          </div>
        </Link>
      </div>

      <div className="nav-list n2">
        <Link className={`nav-item scaleHover opacity ${pathname=="/for-farmers/"?"current":""}`} href="/for-farmers/">
          <div className="title">
            <div className="en"><span className="small">For</span>Farmers</div>
            <div className="sub-title">農家のみなさまへ</div>
          </div>
        </Link>
        <Link className={`nav-item scaleHover opacity ${pathname=="/for-companies/"?"current":""}`} href="/for-companies/">
          <div className="title">
            <div className="en"><span className="small">For</span>Companies</div>
            <div className="sub-title">企業のみなさまへ</div>
          </div>
        </Link>
        <Link className={`nav-item scaleHover opacity ${pathname=="/for-everyone/"?"current":""}`} href="/for-everyone/">
          <div className="title">
            <div className="en"><span className="small">For</span>Everyone</div> 
            <div className="sub-title">みなさまへ</div>
          </div>
        </Link>

        <div className="nav-item-sub">
          <Link className={`nav-item scaleHover opacity en ${pathname=="/news/"?"current":""}`} href="/news/">
            <span>News</span>
          </Link>
          <div className="div"></div>
          <Link className={`nav-item scaleHover opacity en ${pathname=="/contact/"?"current":""}`} href="/contact/">
            <span>Contact</span>
          </Link>
        </div>

        <div className="nav-item-terms">
          <Link className="nav-item-policy scaleHover opacity en" href="/privacy-policy/">
            <span>プライバシーポリシー</span>
          </Link>
          <div className="bginc-logo spOnly en">
            <span>©BG inc.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
